import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
import ContractBaseInfo from './ContractBaseInfo';
import ContractDetail from './ContractDetail';
import ContractSettlement from './ContractSettlement';
import { onMounted, reactive, ref } from "vue";
export default {
  __name: 'ContractInfo',
  props: {
    title: {
      type: String,
      default: '合同详情',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    provinceAction: {
      type: Boolean,
      default: false
    },
    contractAction: {
      type: String
    },
    adminArea: {
      type: String
    }
  },
  emits: ['update:visible', 'refresh'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const activeTab = ref("contract-detail");
    const props = __props;
    const data = reactive({});
    const elLoading = ref(false);
    const close = () => {
      emits('update:visible', false);
    };
    const submit = () => {
      emits('update:visible', false);
      emits('refresh');
    };
    onMounted(() => {});
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        fullscreen: ""
      }, {
        footer: _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", null, [_createVNode(_unref(ContractBaseInfo), {
          contract: __props.contract
        }, null, 8, ["contract"])]), _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeTab.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "合同清单",
            name: "contract-detail"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ContractDetail), {
              contract: __props.contract,
              "is-admin": __props.isAdmin,
              "contract-action": __props.contractAction,
              onSubmit: submit
            }, null, 8, ["contract", "is-admin", "contract-action"])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "合同结算单",
            name: "contract-settlement"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ContractSettlement), {
              "admin-area": __props.adminArea,
              contract: __props.contract,
              "is-admin": __props.isAdmin,
              "contract-action": __props.contractAction,
              "province-action": __props.provinceAction
            }, null, 8, ["admin-area", "contract", "is-admin", "contract-action", "province-action"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])), [[_directive_loading, elLoading.value]])])])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};